var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-img"},[_c('myMask'),_vm._v(" "),_c('div',{staticClass:"modal-img-win flex flex--middle flex--center"},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.closeModal($event)}}},[_c('i',{staticClass:"icon-close"})]),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{ref:"modalContainer",staticClass:"modal-img-container"},[_vm._t("default")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/imgDialog.vue?vue&type=template&id=1aa710f8&
// module id = null
// module chunks = 